<template>
  <div class="course-lesson-item"
       @click="handleClick"
  >
    <div class="item-cover-container">
      <ym-cover :cover="item.cover"
                :alt="item.title"
                :lazy="lazy"
      />
      <ym-icon class="cover-icon"
                name="round-video-fill"
      />
    </div>
    <div class="item-content">
      <h5 class="item-title ym-two-line-ellipsis"
          v-html="item.title"
      ></h5>
      <div class="item-desc">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script>
  import Cover from '@/components/ProductCover';

  export default {
    name: 'CourseLessonItem',
    components: {
      'ym-cover': Cover,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      lazy: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      handleClick() {
        const { item } = this;
        this.$emit('click', item);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course-lesson-item {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding: @size-base 0;
  }

  .item-cover-container {
    flex-shrink: 0;
    margin-right: @size-base;
    position: relative;
  }

  .cover-icon {
    font-size: @course-content-icon-size;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .item-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }

  .item-title {
    margin: 0;
    font-size: @font-size-base;
    line-height: 1.4;
    font-weight: @font-weight-primary;
    /deep/ .highlight {
      color: @color-text-primary;
    }
  }

  .item-desc {
    overflow: hidden;
    color: @color-gray-light;
    font-size: @font-size-small;
  }
</style>
